const PbxxRecord = require('../pbxx_record')

module.exports = class Division extends PbxxRecord {
  static get class_name() {
    return 'Division'
  }
}
